import { classify } from 'sidecar-utilities'

// modalPaddingX is used by header, body, and footer
const modalPaddingX = 'px-5 sm:px-6'

export const bodyStyles = classify({
  height: 'h-auto',
  padding: 'py-4',
  modalPaddingX,
  scrollarea: 'self-stretch overflow-y-auto overflow-x-hidden',
})
